// extracted by mini-css-extract-plugin
export default {"Searchbar":"Searchbar_Searchbar__5WKzV","form":"Searchbar_form__D-hp5","button":"Searchbar_button__nkcjk","label":"Searchbar_label__BRcTT","input":"Searchbar_input__19umw"};